export default __webpack_public_path__ + "static/media/9_fooddiary__april.e32be27e.jpg";